import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { eventTitle, type TitleSource, type Translate } from '@/lib/criticalEvents'

/** #294 — the dashboard's one event title in a component: the critical title for a critical event,
 *  otherwise the translated event type (see eventTitle). */
export function useEventTitle() {
  const { t } = useTranslation('common')
  return useCallback(
    (event: TitleSource | null | undefined, fallback?: string) => eventTitle(event, t as unknown as Translate, fallback),
    [t],
  )
}
